/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-unused-modules */
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import InputAdornment from '@mui/material/InputAdornment';
import LinearProgress from '@mui/material/LinearProgress';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import { makeStyles } from 'tss-react/mui';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { Check, Error } from '@mui/icons-material';
import ChevronRight from '@mui/icons-material/ChevronRight';
import React, { useState, useRef } from 'react';
import {
  CHECK_BLOG_AVAILABILITY,
  CREATE_BLOG,
} from '../../../helpers/graphql/hosting';
import graphQLClient from '../../../helpers/graphQLClient';
import validateSubDomainName from '../../../helpers/validateSubDomainName';
import FormWithDescription from '../FormWithDescription';
import CustomSnackbar from '../Notifications/CustomSnackbar';
import BlogCreationProgress from './BlogCreationProgress';
import SelectPostsTable from './SelectPostsTable';
import AllLogosPicker from './Settings/AllLogosPicker';
import ColorSchemePicker from './Settings/ColorSchemePicker';
import DefaultAddPicker from './Settings/DefaultAddPicker';
import MainOptions from './Settings/MainOptions';

const randomItem = input => {
  return input[Math.floor(Math.random() * input.length)];
};

const useStyles = makeStyles()(theme => ({
  root: {
    width: '100%',
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

function getSteps() {
  return ['Basic options', 'Advanced options', 'Choose posts'];
}

export default function AddBlogWizard({
  isFirstBlog,
  closeWizard,
  setShowAddBlogWizard,
}) {
  const { classes } = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());
  const [blogId, setBlogId] = useState(undefined);
  const [blogTitle, setBlogTitle] = useState();
  const [blogSlogan, setBlogSlogan] = useState();
  const [logo, setLogo] = useState();
  const [logoDimensions, setLogoDimensions] = useState();
  const [squareLogo, setSquareLogo] = useState();
  const [editKey, setEditKey] = useState();
  const [loading, setLoading] = useState(false);

  const [primaryColor, setPrimaryColor] = useState({
    hex: randomItem([
      '#f43f5e',
      '#ec4899',
      '#d946ef',
      '#a855f7',
      '#8b5cf6',
      '#6366f1',
      '#3b82f6',
      '#0ea5e9',
      '#06b6d4',
      '#14b8a6',
      '#10b981',
      '#22c55e',
      '#84cc16',
      '#eab308',
      '#f59e0b',
      '#f97316',
      '#ef4444',
    ]),
  });
  const [defaultAddPosts, setDefaultAddPosts] = useState(true);
  const [blogAvalability, setBlogAvailability] = useState(undefined);
  const [blogCreationStatus, setBlogCreationStatus] = useState();
  const [showValidation, setShowValidation] = useState(false);
  const [showPermlinkWarning, setShowPermlinkWarning] = useState(false);

  const selectedPermlinks = useRef([]);

  const steps = getSteps();

  const handleBlogIdChange = e => {
    const id = e.target.value;
    setBlogId(id.toLowerCase());
    graphQLClient(CHECK_BLOG_AVAILABILITY, {
      id,
    })
      .then(({ checkBlogAvailability }) => {
        setBlogAvailability(checkBlogAvailability);
      })
      .catch(() => setBlogAvailability(false));
  };

  function getStepContent(step) {
    switch (step) {
      case 0:
        // eslint-disable-next-line no-case-declarations
        let validationText = 'Looks good!';
        if (!blogId) validationText = 'Please select a domain';
        else if (validateSubDomainName(blogId))
          validationText = validateSubDomainName(blogId);
        else if (blogAvalability === false)
          validationText = 'Domain is taken - please choose another';

        return (
          <>
            <div>
              <FormWithDescription
                title={
                  <>
                    Pick a subdomain <span className="tw-text-red-400">*</span>
                  </>
                }
                description="You can assign your own domain later."
              >
                <TextField
                  autoFocus
                  fullWidth
                  error={
                    showValidation || (blogId && blogId.length > 3)
                      ? (blogId && validateSubDomainName(blogId) !== null) ||
                        blogAvalability === false ||
                        !blogId
                      : blogAvalability === false
                  }
                  helperText={validationText}
                  id="blogId"
                  label="Subdomain"
                  variant="outlined"
                  value={blogId}
                  onChange={handleBlogIdChange}
                  placeholder="e.g. nomadicninjas"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        {blogAvalability === undefined ? (
                          <span style={{ width: 20 }} />
                        ) : blogAvalability &&
                          !validateSubDomainName(blogId) ? (
                          <Check fontSize="small" />
                        ) : (
                          <Error fontSize="small" />
                        )}
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        .truvvl.blog
                      </InputAdornment>
                    ),
                  }}
                  // eslint-disable-next-line react/jsx-no-duplicate-props
                  inputProps={{
                    maxLength: 16,
                  }}
                />
              </FormWithDescription>
            </div>
            <div className="mt-5" />
            <MainOptions
              setLogoDimensions={setLogoDimensions}
              blogTitle={blogTitle}
              setBlogTitle={setBlogTitle}
              blogSlogan={blogSlogan}
              setBlogSlogan={setBlogSlogan}
              logo={logo}
              setLogo={setLogo}
              squareLogo={squareLogo}
              setSquareLogo={setSquareLogo}
              showValidation={showValidation}
            />
          </>
        );
      case 1:
        return (
          <>
            {!isFirstBlog && (
              <>
                <DefaultAddPicker
                  defaultAddPosts={defaultAddPosts}
                  setDefaultAddPosts={setDefaultAddPosts}
                />
                <div className="mt-5" />
              </>
            )}
            <ColorSchemePicker
              primaryColor={primaryColor}
              setPrimaryColor={setPrimaryColor}
            />
            <AllLogosPicker
              logo={logo}
              setLogo={setLogo}
              setLogoDimensions={setLogoDimensions}
              squareLogo={squareLogo}
              setSquareLogo={setSquareLogo}
            />
          </>
        );
      case 2:
        return (
          <>
            {showPermlinkWarning &&
            (!selectedPermlinks.current ||
              selectedPermlinks.current.length === 0) ? (
              <div className="pb-2">
                <CustomSnackbar
                  variant="error"
                  message="You need to select at least one post"
                />
              </div>
            ) : (
              <></>
            )}
            <SelectPostsTable
              setSelectedPermlinks={newPermlinks => {
                selectedPermlinks.current = newPermlinks;
              }}
            />
          </>
        );
      default:
        return <></>;
    }
  }

  const isStepOptional = step => {
    return step === 1;
  };

  const isStepSkipped = step => {
    return skipped.has(step);
  };

  const handleSubmit = () => {
    setLoading(true);
    graphQLClient(CREATE_BLOG, {
      id: blogId,
      initialPosts: selectedPermlinks.current,
      settings: {
        blogTitle,
        blogSlogan: blogSlogan || `Travel blog by ${blogTitle}`,
        logo,
        logoDimensions,
        squareLogo,
        primaryColor: primaryColor.hex,
        defaultAddPosts,
      },
    })
      .then(({ createBlog }) => {
        if (createBlog && createBlog.message) setEditKey(createBlog.message);
        setBlogCreationStatus(createBlog);
      })
      .catch(err => {
        if (
          err &&
          err.response &&
          err.response.errors &&
          err.response.errors.length > 0 &&
          err.response.errors[0] &&
          err.response.errors[0].message
        )
          setBlogCreationStatus({
            success: false,
            message: err.response.errors[0].message,
          });
      });
  };

  const handleCreateFirstBlog = () => {
    if (
      !blogTitle ||
      !blogId ||
      !blogAvalability ||
      validateSubDomainName(blogId)
    ) {
      setShowValidation(true);
      return;
    }
    handleSubmit();
  };

  const handleNext = () => {
    if (activeStep === 0) {
      if (
        !blogTitle ||
        !blogId ||
        !blogAvalability ||
        validateSubDomainName(blogId)
      ) {
        setShowValidation(true);
        return;
      }
    }

    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    if (activeStep === 2) {
      if (selectedPermlinks.current && selectedPermlinks.current.length > 0)
        handleSubmit();
      else {
        setShowPermlinkWarning(true);
        return;
      }
    }

    setActiveStep(prevActiveStep => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep(prevActiveStep => prevActiveStep + 1);
    setSkipped(prevSkipped => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
    setBlogCreationStatus(undefined);
  };

  return (
    <>
      <div>
        <div className={classes.root}>
          {!isFirstBlog && (
            <div className="stepperHeadings">
              <Stepper activeStep={activeStep}>
                {steps.map((label, index) => {
                  const stepProps = {};
                  const labelProps = {};
                  if (isStepOptional(index)) {
                    labelProps.optional = (
                      <Typography variant="caption">Optional</Typography>
                    );
                  }
                  if (isStepSkipped(index)) {
                    stepProps.completed = false;
                  }
                  return (
                    <Step key={label} {...stepProps}>
                      <StepLabel {...labelProps}>{label}</StepLabel>
                    </Step>
                  );
                })}
              </Stepper>
            </div>
          )}
          <div>
            {blogCreationStatus ? (
              <div>
                <Typography className={classes.instructions}>
                  {blogCreationStatus ? (
                    <>
                      {!blogCreationStatus.success ? (
                        <>
                          <CustomSnackbar
                            variant={
                              blogCreationStatus.success ? 'success' : 'error'
                            }
                            message={blogCreationStatus.message}
                          />
                          <Button
                            onClick={handleReset}
                            className={`mt-2 ${classes.button}`}
                            variant="contained"
                            color="primary"
                          >
                            Go back
                          </Button>
                        </>
                      ) : (
                        <BlogCreationProgress
                          blogId={blogId}
                          editKey={editKey}
                        />
                      )}
                    </>
                  ) : (
                    <>
                      <Box display="flex" alignItems="center">
                        <Box width="100%" mr={1}>
                          <LinearProgress variant="determinate" value={0} />
                        </Box>
                        <Box minWidth={35}>
                          <Typography
                            variant="body2"
                            color="textSecondary"
                          >{`${Math.round(0)}%`}</Typography>
                        </Box>
                      </Box>
                      <Typography variant="body1">
                        Saving your changes...
                      </Typography>
                    </>
                  )}
                </Typography>
              </div>
            ) : isFirstBlog ? (
              <>
                <Typography className={classes.instructions}>
                  {getStepContent(0)}
                  <div className="mt-5" />
                  <ColorSchemePicker
                    primaryColor={primaryColor}
                    setPrimaryColor={setPrimaryColor}
                  />
                </Typography>
                <div className="d-flex justify-content-end mt-5">
                  <Button
                    className="mr-2"
                    onClick={() => setShowAddBlogWizard(false)}
                    variant="outlined"
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleCreateFirstBlog}
                    className={classes.button}
                    disabled={loading}
                  >
                    Create Blog
                  </Button>
                </div>
              </>
            ) : (
              <div>
                <Typography className={classes.instructions}>
                  {getStepContent(activeStep)}
                </Typography>
                <div className="d-flex justify-content-end mt-5">
                  <Button onClick={closeWizard} className={classes.button}>
                    Cancel
                  </Button>
                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    className={classes.button}
                  >
                    Back
                  </Button>
                  {isStepOptional(activeStep) && (
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={handleSkip}
                      className={classes.button}
                    >
                      Skip
                    </Button>
                  )}
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleNext}
                    className={classes.button}
                    disabled={loading}
                  >
                    {activeStep === steps.length - 1 ? 'Create Blog' : 'Next'}
                    <ChevronRight />
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <style jsx>{`
        @media (max-width: 549px) {
          .stepperHeadings {
            margin-left: -40px;
            margin-right: -40px;
          }
        }
      `}</style>
    </>
  );
}
